module.exports = __webpack_public_path__ + "media/images/hc_pulse_logo-8a70c95a2444a4dee2c8268b914fa712.svg";